import { FunctionComponent } from "react";
import { DashboardUsersAdminPartial } from "../../../partials/admin/home/dashboard-users.admin.partials";

export const UsersAdminScreen: FunctionComponent = () => {
  return <DashboardUsersAdminPartial />;
};
